import CachedIcon from "@mui/icons-material/Cached";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Box,
  Breadcrumbs,
  Card,
  TextField,
  Button,
  MenuItem,
  Link,
  Paper,
  Stack,
  TableContainer,
  IconButton,
  Typography,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import Appbar from "../../components/Appbar";
import DrawerUI from "../../components/Drawer";
import Body from "../../layout/Body";
import { userDetailAction } from "../../redux/toolkit/users/userDetail";
import { publisherUserAction } from "../../redux/toolkit/publisherUser/publisherUser";
import { useStyles } from "../../theme/theme";
import { Link as LinkRRD } from "react-router-dom";
// import moment from 'moment'
import { dateFormatStartFun } from "../../helper/dateConverter";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";
import { singlePublisherUserAction } from "../../redux/toolkit/users/parternUsers";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import moment from "moment-timezone";
import SnackBarUI from "../../comman/SnackBarUI";
import { useNavigate } from "react-router-dom";
import BlockUserFromPartner from "./BlockUserFromPartner";
import { userWidthdrawPauseAction } from "../../redux/toolkit/publisherUser/userWidthdrawPause";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";
import { userProfilerAction } from "../../redux/toolkit/publisherUser/userProfiler";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={<NavigateNextIcon sx={{ color: "#fff" }} fontSize="small" />}
      aria-label="breadcrumb"
    >
      <Link underline="hover" sx={{ color: "#000" }} color="inherit" href="/">
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#000" }}
        color="inherit"
        href="/publisher"
      >
        Publisher
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#000" }}
        color="inherit"
        href="/publisher-user"
      >
        Users Profiler Details
      </Link>
    </Breadcrumbs>
    <Typography variant="h5">Publisher Users</Typography>
  </Stack>
);

const UserProfiler = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [publisher, setPublisher] = useState(null);
  const [userId, setUserId] = useState("");

  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const getPublisherSelector = useSelector((state) => state.getPublisher);
  const { data: publiserData } = getPublisherSelector;
  const [status, setStatus] = useState(-1);
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });

  let userProfilerInfo = useSelector((state) => state.userProfilerInfo);
  const { status: profilerStatus, loading, data, total } = userProfilerInfo;

  const missionDetailsColumn = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1,
    },
    {
      field: "p_user_id",
      headerName: "P_User_ID",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        // return (
        //   // <Typography>{params?.row?._id}</Typography>
        //   <LinkRRD to={`/user-transaction?${params?.row?.p_user_id}`}>
        //     <Typography color="primary">{params?.row?.p_user_id}</Typography>
        //   </LinkRRD>
        // );
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <LinkRRD to={`/user-transaction?${params?.row?.p_user_id}`}>
            <Typography color="primary" noWrap>
              {params?.row?.p_user_id}
            </Typography>
          </LinkRRD>
        </Box>;
      },
    },
    {
      field: "publisher_id",
      headerName: "Publisher name",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      // renderCell: (params) => {
      //   return params.row?.publisher_details?.name
      //     ? params.row?.publisher_details?.name
      //     : "---";
      // },
    },

    {
      field: "app_id",
      headerName: "app_id",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "surevy_id",
      headerName: "surevy_id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return params.row.status == 0
          ? "Pending"
          : params.row.status == 1
          ? "Completed"
          : "null";
      },
    },
    {
      field: "raw_amount",
      headerName: "raw_amount",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "publisher_payout",
      headerName: "publisher_payout",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "bonus_amt",
      headerName: "bonus_amt",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "trans_id",
      headerName: "trans_id",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "amountByAdmin",
      headerName: "amountByAdmin",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return params.row.amountByAdmin ? "true" : "false";
      },
    },

    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",

      renderCell: (params) => {
        return moment(params?.row?.createdAt)
          .tz("Asia/Kolkata") // Force conversion to IST
          .format("DD-MM-YYYY hh:mm:ss A");
      },
    },
  ];

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleChange = (event) => {
    setPublisher(event.target.value);
  };

  const handleProfilerData = () => {
    dispatch(
      userProfilerAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        publisher_id: publisher?._id ? publisher?._id : null,
        //   userId: userId ? userId : null,
        status: status,
      })
    );
  };

  useEffect(() => {
    dispatch(getPublisherAction());
  }, []);

  useEffect(() => {
    dispatch(
      userProfilerAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        publisher_id: publisher?._id ? publisher?._id : null,
        //   userId: userId ? userId : null,
        status: status,
      })
    );
  }, [pageState.page, pageState.pageSize]);

  return (
    <>
      <Helmet>
        <title>Real Opinion | User Profiler</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <DrawerUI />

      <Body>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Stack direction="row" spacing={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Min Data/Time"
                value={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, startDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Max Data/Time"
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, endDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            {/* {date?.startDate && date?.endDate && (
              <Button variant="contained" onClick={dateWiseUser}>
                find data
              </Button>
            )} */}
          </Stack>

          {/* <Stack
            sx={{ mt: 1 }}
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Paper
                component="form"
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: 300,
                  backgroundColor: "transparent",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="search By Emails,UserId"
                  inputProps={{
                    "aria-label": "search By Emails And UserId",
                  }}
                  onChange={(e) => setUserId(e.target.value)}
                />
                <IconButton
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                >
                  <SearchIcon onClick={searchHandler} />
                </IconButton>
              </Paper>
            </Stack>
          </Stack> */}

          <Stack direction="row" spacing={2}>
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Publisher</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={publisher?.name}
                  onChange={handleChange}
                >
                  {publiserData?.map((item, i) => (
                    <MenuItem key={i} value={item}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  label="Status"
                  onChange={handleChangeStatus}
                >
                  <MenuItem value={1}>Completed</MenuItem>
                  <MenuItem value={2}>Not Completed</MenuItem>
                  {/* <MenuItem value={30}>Thirty</MenuItem> */}
                </Select>
              </FormControl>
            </Box>

            <Button variant="contained" onClick={handleProfilerData}>
              find data
            </Button>
          </Stack>
        </Stack>

        <Card sx={{ mt: 2 }}>
          <TableContainer sx={{ width: "100%" }}>
            <Stack
              direction={"row"}
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Typography sx={{ ml: 3, my: 2 }} variant="h6">
                Profiler Data : {total}
              </Typography>
            </Stack>

            <Paper
              sx={{
                bgcolor: "#fff",
                "& .super-app-theme--header": {
                  bgcolor: "#071D45",
                  color: "#fff",
                },
              }}
              elevation={0}
            >
              <DataGrid
                className={classes.root}
                getRowHeight={() => "auto"}
                sx={{ border: 0 }}
                autoHeight
                rows={data}
                columns={missionDetailsColumn}
                getRowId={(row) => row._id}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                pagination
                rowsPerPageOptions={[25, 50, 100]}
                disableColumnSelector
                loading={loading ? <LoadingUI /> : false}
                components={{
                  NoRowsOverlay: () => <NoDataFound />,
                }}
                rowCount={total}
                paginationModel={setPageState}
                page={pageState.page}
                pageSize={pageState.pageSize}
                paginationMode="server"
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...old, page: newPage }));
                }}
                onPageSizeChange={(newPageSize) =>
                  setPageState((old) => ({ ...old, pageSize: newPageSize }))
                }
              />
            </Paper>
          </TableContainer>
        </Card>
      </Body>
    </>
  );
};

export default UserProfiler;
